import {http} from '@/http/axios.js'

// 行业
export function getIndustryListAPI(params) {
    return http({
        url: `/api/admin/industry/list`,
        method: 'get',
        params
    })
}

// hr列表
export function getHrListAPI(params) {
    return http({
        url: `/api/admin/hr/list`,
        method: 'get',
        params
    })
}

// 企业列表
export function getBusinessListAPI(params) {
    return http({
        url: `/api/admin/firm/list`,
        method: 'get',
        params
    })
}

// 城市列表
export function getCityListAPI(params) {
    return http({
        url: `/api/admin/workCity/list`,
        method: 'get',
        params
    })
}

export function getDictValueList(dict_key) {
    return http({
        url: `/company/basic/dict-value/list`,
        method: 'get',
        data: {
            dict_key
        }
    })
}


export function getChannelListAPI(type) {
    return http({
        url: `/api/admin/index/getChannelList`,
        method: 'get',
        params: {type}
    })
}
